<template>
  <drag :w="width"
        :h="h"
        :x="body ? scaleToolX: x"
        :y="body ? scaleToolY :y"
        :z="zIndex"
        :drag-handle="'.drag-handle'"
        :resizable="false"
        @dragging="onMove"
        :parent="true" class="scale-tools-resize">
    <div class="scale-tools">
      <div class="drag-handle"></div>
      <div class="footer-1 footer-tool" :class="{'scale-active': scaleToolsFlag === 1}" @click="onResetScale"
           title="等比显示"><span class="scale-icon">1:1</span></div>
      <div class="footer-2 footer-tool" :class="{'scale-active': scaleToolsFlag === 2}" @keydown.stop>
        <div class="scale-center">
          <span class="c-f-left p-m-icon" @click="onMinus" :class="{'c-disabled': value <= 0.1}"
                title="缩小">
            <i class="el-icon-minus"></i>
        </span>
          <!--<span class="scale-icon"  slot="reference">{{Math.round(value * 100)}}%</span>-->
          <el-slider class="scale-slider c-f-left" @input="onChange" :min="0.1" :max="4" :step="0.1" v-model="sliderVal"
                     tooltip-class="c-tooltip-white"
                     :format-tooltip="formatTooltip"></el-slider>
          <span class="c-f-left p-m-icon" @click="onPlus" title="放大"><i class="el-icon-plus"></i></span>
        </div>
      </div>
      <div class="footer-3 footer-tool" :class="{'scale-active': scaleToolsFlag === 3}" @click="setDefaultScale">
        <span class="scale-icon" title="恢复默认"><i class="iconfont icon-default-size"></i></span>
      </div>
    </div>
  </drag>
</template>
<script>
    import drag from '../draggable-resize/draggable-resizable'
    import util from '@/util';
    export default {
        components: {drag},
        props: {
            value: Number,
            defaultScale: Number,
            x: {
                type: Number, default: 0
            },
            y: {
                type: Number, default: 0
            },
            h: {
                type: Number, default: 42
            },
            zIndex: {
                type: Number, default: 1
            },
            body: {
                type: Boolean, default: true
            },
            arrowKey: {
                type: Boolean, default: false
            }
        },
        data() {
            return {
                scaleToolsFlag: null,
                scaleToolX: 0,
                scaleToolY: 0,
                sliderVal: 0,
                sliderVisible: false,
                width: 300
            };
        },
        watch:{
          value: {
            handler(v){
              this.sliderVal = v;
            },
            immediate: true
          },
          sliderVal(v){
            this.$emit('input', v);
          }
        },
        mounted(){
            if(this.body){
                let {offsetWidth, offsetHeight} = document.body;
                let halfWidth = this.width / 2;
                this.scaleToolX = parseInt(offsetWidth / 2 - halfWidth) - this.x;
                this.scaleToolY = offsetHeight - this.y;
            }
            if(this.arrowKey){
                window.addEventListener('keydown', this.onKeydown)
            }
        },
        beforeDestroy(){
            if(this.arrowKey){
                window.removeEventListener('keydown', this.onKeydown)
            }
        },
        methods: {
            onKeydown(evt) { // 快捷键实现放大缩小
                let key = evt.key;
                if(util.isWin()) {
                    if(key === 'ArrowUp') {
                        this.onPlus();
                    } else if (key === 'ArrowDown') {
                        this.onMinus();
                    }
                } else if (util.isMac()) {
                    let keyCode = evt.keyCode;
                    if(keyCode === 187) {  //"+"
                        this.onPlus();
                    } else if (keyCode === 189) { // "-"
                        this.onMinus();
                    }
                }
            },
            onMinus() {
                if (this.value <= 0.1) {
                    return;
                }
                let scale = parseFloat((this.value - 0.1).toFixed(2));
                this.$emit('input', scale);
                this.$emit('onMinus', scale);
                this.$emit('onChange', scale, 'minus')
            },
            onResetScale() {
                this.$emit('input', 1);
                this.$emit('onReset');
                this.$emit('onChange', 1, 'oneAndOne')
            },
            onPlus() {
                let scale = parseFloat((this.value + 0.1).toFixed(2));
                this.$emit('input', scale);
                this.$emit('onPlus', scale);
                this.$emit('onChange', scale, 'plus')
            },
            setDefaultScale() {
                let defaultVal = this.defaultScale ? this.defaultScale : 0.75;
                this.$emit('onDefault', defaultVal);
                this.$emit('input', defaultVal);
                this.$emit('onChange', defaultVal, 'default')
            },
            onMove(){
              this.sliderVisible = false;
            },
            formatTooltip(val){
                return parseInt(val * 100);
            },
            onChange(val){
                this.$emit('onSliderChange', val)
            }
        }
    }
</script>
<style lang="scss">
  @import "index";
</style>